import React, { useState } from "react";
import logo from "../img/logo.png";
import Arrow from "../img/arrow.png";
import imgVec from "../img/imgVec.png";
import {
  doc,
  setDoc,
  getDocs,
  collection,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import { EthereumAuthProvider, SelfID } from "@self.id/web";
import { useNavigate, Link } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import PropagateLoader from "react-spinners/HashLoader";
import { auth } from "../firebase";
const ethereumProvider = window.ethereum;

const Username = () => {
  const [text, setText] = useState("");
  const [modal, setModal] = useState(false);
  const [NFTs, setNFTs] = useState([]);
  const [isnLoading, setIsnLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [url, setUrl] = useState(
    "https://static.vecteezy.com/system/resources/previews/002/318/271/original/user-profile-icon-free-vector.jpg"
  );
  const navigate = useNavigate();
  const css1 = `display: block;`;
  const style = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  };
  const style2 = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  };
  const fetchNFTs = async () => {
    setModal(!modal);
    let nfts;
    const accounts = await ethereumProvider.request({
      method: "eth_requestAccounts",
    });
    const api_key = "hqgLvhxNxeZkyFyZ8AExHl1PcQTQ6BlH";
    const baseURL = `https://eth-mainnet.alchemyapi.io/v2/${api_key}/getNFTs/`;
    var requestOptions = {
      method: "GET",
    };

    const fetchURL = `${baseURL}?owner=0xC1BB39bA8aB14b37d4dD59C457042F639dfef95d`;

    nfts = await fetch(fetchURL, requestOptions).then((data) => data.json());

    if (nfts) {
      setNFTs(nfts.ownedNfts);
      setIsnLoading(false);
    }
  };
  const handleClick = (e, nft) => {
    document.getElementById("img1").src = nft.media[0].gateway;
    document.getElementById("img2").src = nft.media[0].gateway;
    setUrl(nft.media[0].gateway);
  };
  const checkUsername = async () => {
    const q = query(collection(db, "users"), where("displayName", "==", text));
    const res = await getDocs(q);
    if (res.docs.length !== 0) {
      return -1;
    }
  };
  const handleKey = async () => {
    setIsLoading(true);
    try {
      const resp = await checkUsername();
      if (resp === -1) {
        toast.error("Username already exists");
        setIsLoading(false);
        return;
      }
      const accounts = await ethereumProvider.request({
        method: "eth_requestAccounts",
      });
      const authProvider = new EthereumAuthProvider(
        ethereumProvider,
        accounts[0]
      );

      const selfid = await SelfID.authenticate({
        authProvider: authProvider,
        ceramic: "https://ceramic.metagame.wtf/",
        connectNetwork: "mainnet",
        threeidConnect: true,
      });

      await selfid.set("basicProfile", { name: text });
      const ret = await selfid.get("basicProfile");
      await setDoc(doc(db, "users", auth.currentUser.uid), {
        uid: accounts[0],
        displayName: text.toLowerCase(),
        photoURL: url,
        tweetHandle: "",
      });
      navigate("/social");
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="userPage">
      <Toaster position="top-center" reverseOrder={false} />
      {isLoading && (
        <div className="modal">
          <PropagateLoader
            color={"#4d00ac"}
            isLoading={isLoading}
            css={css1}
            size={60}
            style={style2}
          />
        </div>
      )}
      {modal && (
        <div className="modal">
          <div
            className="overlay"
            onClick={() => {
              setModal(!modal);
            }}
          ></div>
          <div className="content">
            <div className="userImage">
              <img src={imgVec} id="img1"></img>
            </div>
            <span className="s1">Choose from your NFTs</span>
            <span className="s2">Selected avatar will appear above.</span>
            <div className="NFT">
              {isnLoading && (
                <PropagateLoader
                  color={"#4d00ac"}
                  isLoading={isnLoading}
                  size={50}
                  css={css1}
                  style={style}
                />
              )}
              {!isnLoading && NFTs.length != 0 && (
                <div className="NFTGrid">
                  {NFTs.map((nft, index) => {
                    return (
                      <img
                        src={nft.media[0].gateway}
                        id={index}
                        onClick={(event) => handleClick(event, nft)}
                        onError={(event) =>
                          (document.getElementById(index).style.display =
                            "None")
                        }
                      ></img>
                    );
                  })}
                </div>
              )}
              {!isnLoading && NFTs.length == 0 && (
                <span className="no">No NFT Found</span>
              )}
            </div>
            <div className="nav">
              <button
                className="done"
                onClick={() => {
                  setModal(!modal);
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="container">
        <div className="name">
          <img src={logo} alt=""></img>
          {/* <span>Doxdom</span> */}
        </div>
        <div className="steps">
          <div className="step">Step 1</div>
          <hr></hr>
          <div className="stepf">Step 2</div>
          <hr></hr>
          <div className="step">Step 3</div>
        </div>
        <div className="enterInfo">
          <span className="setup">Set up your avatar and user name</span>
          <div className="userImage" onClick={fetchNFTs}>
            <img src={imgVec} alt="" id="img2"></img>
          </div>
          <input
            type="text"
            placeholder="Type to search..."
            className="usersname"
            onChange={(e) => setText(e.target.value)}
            // value={username}
          />
          <button className="next" onClick={handleKey}>
            Next
            <img src={Arrow} alt=""></img>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Username;
